export interface LinkConfig {
    text: string;
    href: string;
}

export const LINKS_REAL_ESTATE: LinkConfig[] = [
    {
        text: 'Browse all homes',
        href: '/browse/homes/',
    },
    {
        text: 'Albuquerque real estate',
        href: '/albuquerque-nm/',
    },
    {
        text: 'Atlanta real estate',
        href: '/atlanta-ga/',
    },
    {
        text: 'Austin real estate',
        href: '/austin-tx/',
    },
    {
        text: 'Baltimore real estate',
        href: '/baltimore-md/',
    },
    {
        text: 'Boston real estate',
        href: '/boston-ma/',
    },
    {
        text: 'Calgary real estate',
        href: '/calgary-ab/',
    },
    {
        text: 'Charlotte real estate',
        href: '/charlotte-nc/',
    },
    {
        text: 'Chicago real estate',
        href: '/chicago-il/',
    },
    {
        text: 'Cleveland real estate',
        href: '/cleveland-oh/',
    },
    {
        text: 'Colorado Springs real estate',
        href: '/colorado-springs-co/',
    },
    {
        text: 'Columbus real estate',
        href: '/columbus-oh/',
    },
    {
        text: 'Dallas real estate',
        href: '/dallas-tx/',
    },
    {
        text: 'Denver real estate',
        href: '/denver-co/',
    },
    {
        text: 'Detroit real estate',
        href: '/detroit-mi/',
    },
    {
        text: 'Edmonton real estate',
        href: '/edmonton-ab/',
    },
    {
        text: 'El Paso real estate',
        href: '/el-paso-tx/',
    },
    {
        text: 'Fort Worth real estate',
        href: '/fort-worth-tx/',
    },
    {
        text: 'Fresno real estate',
        href: '/fresno-ca/',
    },
    {
        text: 'Houston real estate',
        href: '/houston-tx/',
    },
    {
        text: 'Indianapolis real estate',
        href: '/indianapolis-in/',
    },
    {
        text: 'Jacksonville real estate',
        href: '/jacksonville-fl/',
    },
    {
        text: 'Kansas City real estate',
        href: '/kansas-city-mo/',
    },
    {
        text: 'Las Vegas real estate',
        href: '/las-vegas-nv/',
    },
    {
        text: 'Long Beach real estate',
        href: '/long-beach-ca/',
    },
    {
        text: 'Los Angeles real estate',
        href: '/los-angeles-ca/',
    },
    {
        text: 'Louisville real estate',
        href: '/louisville-ky/',
    },
    {
        text: 'Memphis real estate',
        href: '/memphis-tn/',
    },
    {
        text: 'Mesa real estate',
        href: '/mesa-az/',
    },
    {
        text: 'Miami real estate',
        href: '/miami-fl/',
    },
    {
        text: 'Milwaukee real estate',
        href: '/milwaukee-wi/',
    },
    {
        text: 'Minneapolis real estate',
        href: '/minneapolis-mn/',
    },
    {
        text: 'Nashville real estate',
        href: '/nashville-tn/',
    },
    {
        text: 'New Orleans real estate',
        href: '/new-orleans-la/',
    },
    {
        text: 'New York real estate',
        href: '/new-york-ny/',
    },
    {
        text: 'Oakland real estate',
        href: '/oakland-ca/',
    },
    {
        text: 'Oklahoma real estate',
        href: '/oklahoma-city-ok/',
    },
    {
        text: 'Omaha real estate',
        href: '/omaha-ne/',
    },
    {
        text: 'Ottawa real estate',
        href: '/ottawa-on/',
    },
    {
        text: 'Philadelphia real estate',
        href: '/philadelphia-pa/',
    },
    {
        text: 'Phoenix real estate',
        href: '/phoenix-az/',
    },
    {
        text: 'Portland real estate',
        href: '/portland-or/',
    },
    {
        text: 'Raleigh real estate',
        href: '/raleigh-nc/',
    },
    {
        text: 'Sacramento real estate',
        href: '/sacramento-ca/',
    },
    {
        text: 'San Antonio real estate',
        href: '/san-antonio-tx/',
    },
    {
        text: 'San Diego real estate',
        href: '/san-diego-ca/',
    },
    {
        text: 'San Francisco real estate',
        href: '/san-francisco-ca/',
    },
    {
        text: 'San Jose real estate',
        href: '/san-jose-ca/',
    },
    {
        text: 'Seattle real estate',
        href: '/seattle-wa/',
    },
    {
        text: 'Toronto real estate',
        href: '/toronto-on/',
    },
    {
        text: 'Tucson real estate',
        href: '/tucson-az/',
    },
    {
        text: 'Tulsa real estate',
        href: '/tulsa-ok/',
    },
    {
        text: 'Vancouver real estate',
        href: '/vancouver-bc/',
    },
    {
        text: 'Virginia Beach real estate',
        href: '/virginia-beach-va/',
    },
    {
        text: 'Washington DC real estate',
        href: '/washington-dc/',
    },
    {
        text: 'Wichita real estate',
        href: '/wichita-ks/',
    },
];

export const LINKS_RENTALS: LinkConfig[] = [
    {
        text: 'Rental Buildings',
        href: '/browse/b/',
    },
    {
        text: 'Atlanta apartments for rent',
        href: '/atlanta-ga/apartments/',
    },
    {
        text: 'Austin apartments for rent',
        href: '/austin-tx/apartments/',
    },
    {
        text: 'Baltimore apartments for rent',
        href: '/baltimore-md/apartments/',
    },
    {
        text: 'Boston apartments for rent',
        href: '/boston-ma/apartments/',
    },
    {
        text: 'Bronx NYC apartments for rent',
        href: '/bronx-new-york-city-ny/apartments/',
    },
    {
        text: 'Brooklyn NYC apartments for rent',
        href: '/brooklyn-new-york-city-ny/apartments/',
    },
    {
        text: 'Charlotte apartments for rent',
        href: '/charlotte-nc/apartments/',
    },
    {
        text: 'Chicago apartments for rent',
        href: '/chicago-il/apartments/',
    },
    {
        text: 'Dallas apartments for rent',
        href: '/dallas-tx/apartments/',
    },
    {
        text: 'Denver apartments for rent',
        href: '/denver-co/apartments/',
    },
    {
        text: 'Houston apartments for rent',
        href: '/houston-tx/apartments/',
    },
    {
        text: 'Jersey City apartments for rent',
        href: '/jersey-city-nj/apartments/',
    },
    {
        text: 'Long Beach apartments for rent',
        href: '/long-beach-ca/apartments/',
    },
    {
        text: 'Manhattan NYC apartments for rent',
        href: '/manhattan-new-york-city-ny/apartments/',
    },
    {
        text: 'Miami apartments for rent',
        href: '/miami-fl/apartments/',
    },
    {
        text: 'Minneapolis apartments for rent',
        href: '/minneapolis-mn/apartments/',
    },
    {
        text: 'New York City apartments for rent',
        href: '/new-york-city-ny/apartments/',
    },
    {
        text: 'Oakland apartments for rent',
        href: '/oakland-ca/apartments/',
    },
    {
        text: 'Oklahoma City apartments for rent',
        href: '/oklahoma-city-ok/apartments/',
    },
    {
        text: 'Philadelphia apartments for rent',
        href: '/philadelphia-pa/apartments/',
    },
    {
        text: 'Queens NYC apartments for rent',
        href: '/queens-new-york-city-ny/apartments/',
    },
    {
        text: 'Sacramento apartments for rent',
        href: '/sacramento-ca/apartments/',
    },
    {
        text: 'San Francisco apartments for rent',
        href: '/san-francisco-ca/apartments/',
    },
    {
        text: 'Seattle apartments for rent',
        href: '/seattle-wa/apartments/',
    },
    {
        text: 'Washington DC apartments for rent',
        href: '/washington-dc/apartments/',
    },
    {
        text: 'Atlanta houses for rent',
        href: '/atlanta-ga/rent-houses/',
    },
    {
        text: 'Austin houses for rent',
        href: '/austin-tx/rent-houses/',
    },
    {
        text: 'Boston houses for rent',
        href: '/boston-ma/rent-houses/',
    },
    {
        text: 'Charlotte houses for rent',
        href: '/charlotte-nc/rent-houses/',
    },
    {
        text: 'Columbus houses for rent',
        href: '/columbus-oh/rent-houses/',
    },
    {
        text: 'Fort Worth houses for rent',
        href: '/fort-worth-tx/rent-houses/',
    },
    {
        text: 'Fresno houses for rent',
        href: '/fresno-ca/rent-houses/',
    },
    {
        text: 'Houston houses for rent',
        href: '/houston-tx/rent-houses/',
    },
    {
        text: 'Indianapolis houses for rent',
        href: '/indianapolis-in/rent-houses/',
    },
    {
        text: 'Jacksonville houses for rent',
        href: '/jacksonville-fl/rent-houses/',
    },
    {
        text: 'Las Vegas houses for rent',
        href: '/las-vegas-nv/rent-houses/',
    },
    {
        text: 'Memphis houses for rent',
        href: '/memphis-tn/rent-houses/',
    },
    {
        text: 'Milwaukee houses for rent',
        href: '/milwaukee-wi/rent-houses/',
    },
    {
        text: 'Nashville houses for rent',
        href: '/nashville-tn/rent-houses/',
    },
    {
        text: 'Oakland houses for rent',
        href: '/oakland-ca/rent-houses/',
    },
    {
        text: 'Oklahoma City houses for rent',
        href: '/oklahoma-city-ok/rent-houses/',
    },
    {
        text: 'Philadelphia houses for rent',
        href: '/philadelphia-pa/rent-houses/',
    },
    {
        text: 'Phoenix houses for rent',
        href: '/phoenix-az/rent-houses/',
    },
    {
        text: 'Portland houses for rent',
        href: '/portland-or/rent-houses/',
    },
    {
        text: 'San Antonio houses for rent',
        href: '/san-antonio-tx/rent-houses/',
    },
    {
        text: 'San Francisco houses for rent',
        href: '/san-francisco-ca/rent-houses/',
    },
    {
        text: 'San Jose houses for rent',
        href: '/san-jose-ca/rent-houses/',
    },
    {
        text: 'Tampa houses for rent',
        href: '/tampa-fl/rent-houses/',
    },
    {
        text: 'Tucson houses for rent',
        href: '/tucson-az/rent-houses/',
    },
    {
        text: 'Washington DC houses for rent',
        href: '/washington-dc/rent-houses/',
    },
];

export const LINKS_MORTGAGE: LinkConfig[] = [
    {
        text: 'Current mortgage rates',
        href: '/mortgage-rates/',
    },
    {
        text: 'Alaska mortgage rates',
        href: '/mortgage-rates/ak/',
    },
    {
        text: 'Alabama mortgage rates',
        href: '/mortgage-rates/al/',
    },
    {
        text: 'Arkansas mortgage rates',
        href: '/mortgage-rates/ar/',
    },
    {
        text: 'Arizona mortgage rates',
        href: '/mortgage-rates/az/',
    },
    {
        text: 'California mortgage rates',
        href: '/mortgage-rates/ca/',
    },
    {
        text: 'Colorado mortgage rates',
        href: '/mortgage-rates/co/',
    },
    {
        text: 'Connecticut mortgage rates',
        href: '/mortgage-rates/ct/',
    },
    {
        text: 'Delaware mortgage rates',
        href: '/mortgage-rates/de/',
    },
    {
        text: 'Florida mortgage rates',
        href: '/mortgage-rates/fl/',
    },
    {
        text: 'Georgia mortgage rates',
        href: '/mortgage-rates/ga/',
    },
    {
        text: 'Hawaii mortgage rates',
        href: '/mortgage-rates/hi/',
    },
    {
        text: 'Iowa mortgage rates',
        href: '/mortgage-rates/ia/',
    },
    {
        text: 'Idaho mortgage rates',
        href: '/mortgage-rates/id/',
    },
    {
        text: 'Illinois mortgage rates',
        href: '/mortgage-rates/il/',
    },
    {
        text: 'Indiana mortgage rates',
        href: '/mortgage-rates/in/',
    },
    {
        text: 'Kansas mortgage rates',
        href: '/mortgage-rates/ks/',
    },
    {
        text: 'Kentucky mortgage rates',
        href: '/mortgage-rates/ky/',
    },
    {
        text: 'Louisiana mortgage rates',
        href: '/mortgage-rates/la/',
    },
    {
        text: 'Massachusetts mortgage rates',
        href: '/mortgage-rates/ma/',
    },
    {
        text: 'Maryland mortgage rates',
        href: '/mortgage-rates/md/',
    },
    {
        text: 'Maine mortgage rates',
        href: '/mortgage-rates/me/',
    },
    {
        text: 'Michigan mortgage rates',
        href: '/mortgage-rates/mi/',
    },
    {
        text: 'Minnesota mortgage rates',
        href: '/mortgage-rates/mn/',
    },
    {
        text: 'Missouri mortgage rates',
        href: '/mortgage-rates/mo/',
    },
    {
        text: 'Mississippi mortgage rates',
        href: '/mortgage-rates/ms/',
    },
    {
        text: 'Montana mortgage rates',
        href: '/mortgage-rates/mt/',
    },
    {
        text: 'North Carolina mortgage rates',
        href: '/mortgage-rates/nc/',
    },
    {
        text: 'North Dakota mortgage rates',
        href: '/mortgage-rates/nd/',
    },
    {
        text: 'Nebraska mortgage rates',
        href: '/mortgage-rates/ne/',
    },
    {
        text: 'New Hampshire mortgage rates',
        href: '/mortgage-rates/nh/',
    },
    {
        text: 'New Jersey mortgage rates',
        href: '/mortgage-rates/nj/',
    },
    {
        text: 'New Mexico mortgage rates',
        href: '/mortgage-rates/nm/',
    },
    {
        text: 'Nevada mortgage rates',
        href: '/mortgage-rates/nv/',
    },
    {
        text: 'New York mortgage rates',
        href: '/mortgage-rates/ny/',
    },
    {
        text: 'Ohio mortgage rates',
        href: '/mortgage-rates/oh/',
    },
    {
        text: 'Oklahoma mortgage rates',
        href: '/mortgage-rates/ok/',
    },
    {
        text: 'Oregon mortgage rates',
        href: '/mortgage-rates/or/',
    },
    {
        text: 'Pennsylvania mortgage rates',
        href: '/mortgage-rates/pa/',
    },
    {
        text: 'Rhode Island mortgage rates',
        href: '/mortgage-rates/ri/',
    },
    {
        text: 'South Carolina mortgage rates',
        href: '/mortgage-rates/sc/',
    },
    {
        text: 'South Dakota mortgage rates',
        href: '/mortgage-rates/sd/',
    },
    {
        text: 'Tennessee mortgage rates',
        href: '/mortgage-rates/tn/',
    },
    {
        text: 'Texas mortgage rates',
        href: '/mortgage-rates/tx/',
    },
    {
        text: 'Utah mortgage rates',
        href: '/mortgage-rates/ut/',
    },
    {
        text: 'Virginia mortgage rates',
        href: '/mortgage-rates/va/',
    },
    {
        text: 'Vermont mortgage rates',
        href: '/mortgage-rates/vt/',
    },
    {
        text: 'Washington mortgage rates',
        href: '/mortgage-rates/wa/',
    },
    {
        text: 'Wisconsin mortgage rates',
        href: '/mortgage-rates/wi/',
    },
    {
        text: 'West Virginia mortgage rates',
        href: '/mortgage-rates/wv/',
    },
    {
        text: 'Wyoming mortgage rates',
        href: '/mortgage-rates/wy/',
    },
];

export const LINKS_BROWSE_HOMES: LinkConfig[] = [
    {
        text: 'California',
        href: '/browse/homes/ca/',
    },
    {
        text: 'Texas',
        href: '/browse/homes/tx/',
    },
    {
        text: 'New York',
        href: '/browse/homes/ny/',
    },
    {
        text: 'Florida',
        href: '/browse/homes/fl/',
    },
    {
        text: 'Illinois',
        href: '/browse/homes/il/',
    },
    {
        text: 'Pennsylvania',
        href: '/browse/homes/pa/',
    },
    {
        text: 'Ohio',
        href: '/browse/homes/oh/',
    },
    {
        text: 'Michigan',
        href: '/browse/homes/mi/',
    },
    {
        text: 'Georgia',
        href: '/browse/homes/ga/',
    },
    {
        text: 'North Carolina',
        href: '/browse/homes/nc/',
    },
    {
        text: 'New Jersey',
        href: '/browse/homes/nj/',
    },
    {
        text: 'Virginia',
        href: '/browse/homes/va/',
    },
    {
        text: 'Washington',
        href: '/browse/homes/wa/',
    },
    {
        text: 'Massachusetts',
        href: '/browse/homes/ma/',
    },
    {
        text: 'Indiana',
        href: '/browse/homes/in/',
    },
    {
        text: 'Arizona',
        href: '/browse/homes/az/',
    },
    {
        text: 'Tennessee',
        href: '/browse/homes/tn/',
    },
    {
        text: 'Missouri',
        href: '/browse/homes/mo/',
    },
    {
        text: 'Maryland',
        href: '/browse/homes/md/',
    },
    {
        text: 'Wisconsin',
        href: '/browse/homes/wi/',
    },
    {
        text: 'Minnesota',
        href: '/browse/homes/mn/',
    },
    {
        text: 'Colorado',
        href: '/browse/homes/co/',
    },
    {
        text: 'Alabama',
        href: '/browse/homes/al/',
    },
    {
        text: 'South Carolina',
        href: '/browse/homes/sc/',
    },
    {
        text: 'Louisiana',
        href: '/browse/homes/la/',
    },
    {
        text: 'Kentucky',
        href: '/browse/homes/ky/',
    },
    {
        text: 'Oregon',
        href: '/browse/homes/or/',
    },
    {
        text: 'Oklahoma',
        href: '/browse/homes/ok/',
    },
    {
        text: 'Connecticut',
        href: '/browse/homes/ct/',
    },
    {
        text: 'Iowa',
        href: '/browse/homes/ia/',
    },
    {
        text: 'Mississippi',
        href: '/browse/homes/ms/',
    },
    {
        text: 'Arkansas',
        href: '/browse/homes/ar/',
    },
    {
        text: 'Kansas',
        href: '/browse/homes/ks/',
    },
    {
        text: 'Utah',
        href: '/browse/homes/ut/',
    },
    {
        text: 'Nevada',
        href: '/browse/homes/nv/',
    },
    {
        text: 'New Mexico',
        href: '/browse/homes/nm/',
    },
    {
        text: 'West Virginia',
        href: '/browse/homes/wv/',
    },
    {
        text: 'Nebraska',
        href: '/browse/homes/ne/',
    },
    {
        text: 'Idaho',
        href: '/browse/homes/id/',
    },
    {
        text: 'Hawaii',
        href: '/browse/homes/hi/',
    },
    {
        text: 'Maine',
        href: '/browse/homes/me/',
    },
    {
        text: 'New Hampshire',
        href: '/browse/homes/nh/',
    },
    {
        text: 'Rhode Island',
        href: '/browse/homes/ri/',
    },
    {
        text: 'Montana',
        href: '/browse/homes/mt/',
    },
    {
        text: 'Delaware',
        href: '/browse/homes/de/',
    },
    {
        text: 'South Dakota',
        href: '/browse/homes/sd/',
    },
    {
        text: 'Alaska',
        href: '/browse/homes/ak/',
    },
    {
        text: 'North Dakota',
        href: '/browse/homes/nd/',
    },
    {
        text: 'Vermont',
        href: '/browse/homes/vt/',
    },
    {
        text: 'Washington, DC',
        href: '/browse/homes/dc/district-of-columbia-county/',
    },
    {
        text: 'Wyoming',
        href: '/browse/homes/wy/',
    },
    {
        text: 'Puerto Rico',
        href: '/browse/homes/pr/',
    },
    {
        text: 'Virgin Islands',
        href: '/browse/homes/vi/',
    },
];
